import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";

import { ITermTranslationsState, ITermTranslation, getInitialTermTranslationsState } from "./TermTranslations.state";

const initialState = getInitialTermTranslationsState();

export const termTranslations = createSlice({
  name: "termTranslations",
  initialState: initialState,
  reducers: {
    loadTermTranslations: actionProcessing.createWithClearNotification((state: ITermTranslationsState) => {
      return {
        ...state,
        isLoading: true
      };
    }),
    loadTermTranslationsCompleted: actionProcessing.createWithClearNotification((state: ITermTranslationsState, action: PayloadAction<ITermTranslation[]>) => {
      return {
        ...state,
        translations: action.payload,
        isLoading: false
      };
    }),
    loadTermTranslationsFailed: (state: ITermTranslationsState, action: PayloadAction<INotification>) => {
      return {
        ...state,
        translations: [],
        notifications: [...state.notifications, action.payload],
        isLoading: false
      };
    },
    clearState: actionProcessing.createWithClearNotification(() => {
      return {
        ...initialState
      };
    })
  },
  extraReducers: getScreenExtraReducers<ITermTranslationsState>("notifications", initialState)
});
